<template>
<div class="chapter">
<div class="inner_page">
<a id="p3"></a>
<p class="sink"> </p>
<p class="center ">The forbidden holds a secret attraction.</p>
<p class="center ">—<span class="smallcaps">TACITUS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?22a6f8ce